import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

//pictures here
import meta from './pictures/meta.png';

const Meta= () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Open Networking & Breakfast with Meta!</h2>
                    <p class="site-post-meta">November 14th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members!
                    <br></br>
                    <br></br>
                    On Thursday, November 14th, WiC hosted our Breakfast & Networking with Meta event! We had the opportunity to connect with the amazing Meta team and hear from them about their unique career paths. Attendees got the chance to ask questions to a panel, receive valuable recruiting insights, and enjoy some great food. Thank you to everyone who joined us!
                    </p>
                    <img src={meta} alt="pic1 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Meta;